//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from "../components/NavBar.vue";
import Popular from "../components/Popular.vue";
import Tweets from "../components/Tweets.vue";
import MainCard from "../components/MainTitle.vue";
import CreateTweets from "../components/CreateTweet.vue";
import tweetsAPI from "./../apis/tweets";
import { Toast } from "./../utils/helpers";
import BetterScroll from "better-scroll";
import store from "./../store";

export default {
  name: "Main",
  components: {
    NavBar,
    Popular,
    Tweets,
    MainCard,
    CreateTweets,
  },
  data() {
    return {
      currentUser: {
        id: "",
        avatar: "",
        name: "",
      },
      tweets: [],
      popularUpdate: false,
    };
  },
  mounted() {
    this.fetchUserInfo();
    this.fetchTweets();
    this.movefunction(1000);
  },
  methods: {
    fetchUserInfo() {
      const { account, avatar, id } = store.state.currentUser;
      this.currentUser = { account, avatar, id };
    },
    async fetchTweets() {
      try {
        const { data } = await tweetsAPI.getTweets();
        this.tweets = data;
      } catch (error) {
        console.log(error);
        Toast.fire({
          icon: "warning",
          title: "無法取得推文，請稍後再試",
        });
      }
    },
    movefunction(s) {
      return new Promise(function (resolve) {
        setTimeout(() => {
          resolve(
            new BetterScroll(".contents", {
              mouseWheel: true, //開啟滑鼠滾動
              disableMouse: false, //關閉滑鼠拖動
              disableTouch: false, //關閉手指觸摸
              scrollX: true, //X軸滾動開啟
              click: true,
            })
          );
        }, s);
      });
    },
    afterCreateTweet() {
      // console.log(payload);
      // 作法1. 把輸入的資料先加進tweets陣列，先不重新fetchTweets。
      //    但資料要包含完整資訊，不能只有description，並且要加在Array最前
      // const description = payload;
      // this.tweets.push({
      //   description,
      // });

      // 作法2. 直接重新fetchAPI
      this.fetchTweets();
    },
  },
};
